<template>
  <div class="details">
    <div class="list-header">Videos Details</div>
    <div class="scroll-box">
      <div
        class="video-details-content"
        v-if="video.xml_vod_data"
      >

        <img
          class="video-image2"
          v-bind:src="tmdb_image_url"
          onerror="this.src='http://images.mixd.tv/images/default.png'"
          type="image/png" />

        <div>
          <p class="video-title">{{ video.title }}</p>
          <div class="col-md-12 sub-headline">
              {{ video.target_data.dmb_genre }}
          </div>
          <p
            class="video-data"
            v-if="video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__11_serie"
          >
            (S{{ video.target_data.season_number | fillToTwoDigits }}E{{ video.target_data.episode_number | fillToTwoDigits }})
            - {{ video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__11_serie.folgentitel }}
            ({{ video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__11_serie.originalfolgentitel }})
            <br />
            <p
              class="video-info"
              v-if="video.vod_type === 'series' && (video.source_data.season !== video.target_data.season_number || video.source_data.episode !== video.target_data.episode_number)"
            >
              => Different Numbers on VoD Plattform: <b>S{{ video.source_data.season | fillToTwoDigits }}E{{ video.source_data.episode | fillToTwoDigits }}</b> (see log)
            </p>
            <p
              class="video-info"
              v-if="video.vod_type === 'series'"
            >
              Folgennummer (online Datenbank): <b>{{ video.target_data.episode_number }}</b>
            </p>
            <p
              class="video-info"
              v-if="video.vod_type === 'series'"
            >
              Folgennummer (VoD-Anbieter): <b>{{ video.target_data.episode_number_in_source }}</b>
            </p>
            <br />
            <p
              class="video-text"
              v-if="video.target_data.description"
            >
              <b>TMDB Description:</b> {{ video.target_data.description | truncate(1500) }}
            </p>
            <p
              class="video-text"
              v-if="video.target_data.synopsis"
            >
              <b>Anbieter Synopsis:</b> {{ video.target_data.synopsis | truncate(1500) }}
            </p>
        </div>
      </div>

      <div class="devider"></div>
      <div class="info-box">
        <div class="list-header">Exported Data (German)</div>
        <b-row class="video-details-content">
          <b-col cols="12" class="mui--text-left">
            <p class="video-title">
              {{ video.title }}
              <span
                class="badge badge-primary"
                v-if="video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__04_ausstrahlung.__sort__20_anbieter_original && video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__04_ausstrahlung.__sort__20_anbieter_original === true"
              >
                anbiter_orignal
              </span>

              <span
                class="badge badge-secondary"
                v-if="video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__04_ausstrahlung.__sort__21_anbieter_exclusive && video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__04_ausstrahlung.__sort__21_anbieter_exclusive === true"
              >
                anbiter_exclusive
              </span>

              <span
                class="badge badge-success"
                v-if="video.vod_type !== 'movies' && video.source_data.delta_info === 'update' && video.source_data.delta_info !== 'deleted' &&
                  parseInt(video.xml_vod_data.sendung.__sort__01_id.substr(5,6)) <= 0"
              >
                Serien-Update
              </span>
              <span
                class="badge badge-warning"
                v-if="video.vod_type !== 'movies' && video.source_data.delta_info === 'update' && video.source_data.delta_info !== 'deleted' &&
                  !parseInt(video.xml_vod_data.sendung.__sort__01_id.substr(5,6)) <= 0"
              >
                Staffel-Update
              </span>
            </p>

            <p
              class="video-text-dark"
              v-if="video.source_data.delta_info !== 'update' && video.source_data.delta_info !== 'deleted'"
            >
              <b>Beschreibung:</b> {{ video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__10_beschreibung | truncate(1500)}}
              <!-- {{ video.target_data.description | truncate(1500) }} -->
            </p>
          </b-col>
        </b-row>
        <b-row
          class="video-details-content"
        >
          <b-col
            cols="4"
            class="mui--text-left"
          >
            <p
              class="video-data"
              v-if="!video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__11_serie && video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__02_originaltitel"
            >
              Originaltitel: {{ video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__02_originaltitel }}
            </p>
            <p
              class="video-data"
              v-if="video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__11_serie"
            >
              Episodentitel: {{ video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__11_serie.folgentitel }}
            </p>
            <p
              class="video-data"
              v-if="video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__11_serie"
            >
              Original-Episodentitel: {{ video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__11_serie.originalfolgentitel }}
            </p>
            <!-- <p class="video-data">Season/Episode Title (Series): S{{
              video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__02_originaltitel
            }}E{{
              video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__02_originaltitel
            }}</p>
            <p class="video-data">Episode Title (Series): <a v-bind:href="video.source_data.episodeurl">{{ video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__02_originaltitel }}</a></p> -->
            <p
              class="video-data"
              v-if="video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__17_produktion"
            >
              Jahr: {{ video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__17_produktion.__sort__02_jahr }}
            </p>
            <br />
            <p
              class="video-data"
              v-if="video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__18_personen"
            >
              Regie: {{ video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__18_personen.__sort__02_regie }}
            </p>
            <p
              class="video-data"
              v-if="video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__05_dmb_genre"
            >
              Haupgenre: {{ video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__05_dmb_genre.dmb_haupt_genre }}
            </p>
            <p
              class="video-data"
              v-if="video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__05_dmb_genre"
            >
              Nebengenre: {{ video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__05_dmb_genre.dmb_neben_genre }}
            </p>
            <p
              class="video-data"
              v-if="video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__04_ausstrahlung.__sort__19_katalog_genre"
            >
              Kataloggenre: {{ video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__04_ausstrahlung.__sort__19_katalog_genre }}
            </p>
            <p
              class="video-data"
              v-if="video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__04_ausstrahlung.__sort__04_dauer"
            >
              Länge: {{ video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__04_ausstrahlung.__sort__04_dauer }} min
            </p>
            <!-- <p class="video-data">Actors: {{ video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__02_originaltitel }}</p> -->
            <!-- <p class="video-data">Language: {{ video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__02_originaltitel }}</p> -->
            <p
              class="video-data"
              v-if="video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__17_produktion && video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__17_produktion.__sort__04_ProduktionsLaender"
            >
              Produktionsländer: {{ video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__17_produktion.__sort__04_ProduktionsLaender.__sort__000001_ProduktionsLand | showCountry }}
            </p>
            <p
              class="video-data"
              v-if="video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__06_altersempfehlung"
            >
              Altersempfehlung: {{ video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__06_altersempfehlung }}
            </p>
            <!-- <p class="video-data">HD: {{ video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__04_ausstrahlung.__sort__15_video-attribute.__sort__15_hdtv }}</p>
            <p class="video-data">UHD: {{ video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__04_ausstrahlung.__sort__15_video-attribute.__sort__16_uhd }}</p>
            <p class="video-data">OmU: {{ video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__04_ausstrahlung.__sort__15_video-attribute.__sort__04_omu }}</p> -->
            <br />
            <p class="video-data">Bald Endend: {{ video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__04_ausstrahlung.__sort__18_bald_endend }}</p>
            <p class="video-data">Auf Highlights-Liste: {{ video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__04_ausstrahlung.__sort__14_sender_highlight }}</p>
            <p class="video-data">Neuerscheinung: {{ video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__04_ausstrahlung.__sort__17_auf_neuerscheinungsliste }}</p>
            <p class="video-data">Auf Beliebtliste: {{ video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__04_ausstrahlung.__sort__16_auf_beliebtliste }}</p>
          </b-col>
          <b-col cols="4" class="mui--text-left">
            <p class="video-data">VoD Anbieter:
              <a v-bind:href="video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__20_web_url">
                {{
                  video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__04_ausstrahlung.__sort__06_sender
                }}
              </a>
              <!-- ({{
                video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__04_ausstrahlung.__sort__13_sendergenre.includes('axdome') ? 'Maxdome' : video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__04_ausstrahlung.__sort__13_sendergenre
              }}) -->
              <a v-bind:href="video.target_data.web_url">
                <div v-if="(!!video.target_data.web_url && video.target_data.web_url.includes('store.maxdome.de')) || (!!video.target_data.web_url_ppv)" class="floater badge badge-info">
                  PPV
                </div>
              </a>
              <a v-bind:href="video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__20_web_url">
                <div v-if="(!!video.target_data.web_url && video.target_data.web_url.includes('store.maxdome.de')) || (!!video.target_data.web_url_ppv)" class="floater badge badge-info">
                  ABO
                </div>
              </a>
            </p>
            <p class="video-data">
              (
              <a v-bind:href="video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__20_web_url">web</a> |
              <a v-bind:href="video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__21_ios_inapp_url_details">iOS details</a> |
              <a v-bind:href="video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__22_ios_inapp_url_play">iOS play</a> |
              <a v-bind:href="video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__23_android_intend_url_details">Android details</a> |
              <a v-bind:href="video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__24_android_intend_url_play">Android play</a>
              )
            </p>
            <div class="video-data">
              <p class="badge badge-primary" v-if="hasFlagHdtv">Flag HD</p>
              <p class="badge badge-primary" v-if="hasFlagUhd">Flag UHD</p>
            </div>

            <div class="video-data">
              buy:
              <p class="badge badge-info" v-if="prices.buy">SD: {{prices.buy.sd}}</p>
              <p class="badge badge-info" v-if="prices.buy">HD: {{prices.buy.hd}}</p>
              <p class="badge badge-info" v-if="prices.buy">UHD: {{prices.buy.uhd}}</p>
            </div>

            <div class="video-data">
              rent:
              <p class="badge badge-danger" v-if="prices.rent">SD: {{prices.rent.sd}}</p>
              <p class="badge badge-danger" v-if="prices.rent">HD: {{prices.rent.hd}}</p>
              <p class="badge badge-danger" v-if="prices.rent">UHD: {{prices.rent.uhd}}</p>
            </div>

            <p
              class="video-data"
              v-if="video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__04_ausstrahlung.__sort__22_BuyPrice"
            >Kaufen: {{ video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__04_ausstrahlung.__sort__22_BuyPrice }} €</p>

            <p class="video-data">Catalogs:
              <a :href="targetImdbUrl" v-if="targetImdbUrl">IMDb</a>
              <a :href="targetTmdbUrl" v-if="targetTmdbUrl">TMDb</a>
              <a :href="targetTvdbUrl" v-if="targetTvdbUrl">tvdb</a>
            </p>

            <p
              class="video-data"
              v-if="video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__04_ausstrahlung.__sort__01_start"
            >Platform Start: {{ video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__04_ausstrahlung.__sort__01_start | moment("MMMM Do YYYY") }}</p>
            <p
              class="video-data"
              v-if="video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__04_ausstrahlung.__sort__03_stop"
            >Platform End: {{ this.video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__04_ausstrahlung.__sort__03_stop }}</p>
            <br />
            <div
              v-if="video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__18_personen"
            >
              <p class="video-data">Kamera: {{ video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__18_personen.__sort__03_kamera }}</p>
              <p class="video-data">Drehbuch: {{ video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__18_personen.__sort__04_drehbuch }}</p>
              <p class="video-data">Musik: {{ video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__18_personen.__sort__05_musik }}</p>
              <p class="video-data">Author: {{ video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__18_personen.__sort__06_autor }}</p>
              <p class="video-data">Produzent: {{ video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__18_personen.__sort__07_produzent }}</p>
              <p class="video-data">Creator: {{ video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__18_personen.__sort__08_creator }}</p>
              <p class="video-data">Szenenbild: {{ video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__18_personen.__sort__09_szenenbild }}</p>
              <p class="video-data">Kostüme: {{ video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__18_personen.__sort__10_kostueme }}</p>
              <p class="video-data">Schnitt: {{ video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__18_personen.__sort__11_schnitt }}</p>

              <p class="video-data"> Actors:
                <!-- <div v-for="(roll, index) in video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__18_personen.__sort__01_besetzung" :key="index">
                  {{ roll }}
                </div> -->
                {{ video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__18_personen.__sort__01_besetzung }}
              </p>
              <br />
            </div>
            <p class="video-data"><pre>Fremd-ID: {{ video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__01_metadaten.__sort__04_idnr }}</pre></p>
          </b-col>
          <b-col cols="4" class="mui--text-left season-data">
            <p class="video-data">
              <b>Serien Daten</b>
            <p
              class="video-data"
              v-if="video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__11_serie && video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__11_serie.serien_hinweis"
            >
              Platform Start: {{ video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__11_serie.serien_hinweis.__sort__25_start | moment("MMMM Do YYYY") }}
            </p>
            <p
              class="video-data"
              v-if="video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__11_serie && video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__11_serie.serien_hinweis"
            >
              Platform End: {{ video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__11_serie.serien_hinweis.__sort__26_stop | moment("MMMM Do YYYY") }}
            </p>
            <p
              class="video-text-dark"
              v-if="video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__11_serie && video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__11_serie.serien_hinweis"
            >
              Serien Beschreibung: {{ burdaSeriesSynopsis }}
            </p>
            <p
              class="video-text-dark"
              v-if="video.source_data.delta_info === 'update' && video.source_data.delta_info !== 'deleted' &&
                parseInt(video.xml_vod_data.sendung.__sort__01_id.substr(5,6)) <= 0"
            >
              Serien Beschreibung: {{ burdaSeriesSynopsis }}
            </p>
            <p
              class="video-data"
              v-if="video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__11_serie && video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__11_serie.serien_hinweis"
            >
              TVDB ID: <a v-bind:href="this.tvdbSeriesUrl" v-if="this.tvdbSeriesUrl">{{ video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__11_serie.serien_hinweis.__sort__35_tvdb_id }}</a>
            </p>
            <p
              class="video-data"
              v-if="video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__11_serie && video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__11_serie.serien_hinweis"
            >
              VoD Genre: {{ video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__11_serie.serien_hinweis.__sort__27_sendergenre }}
            </p>
            <p
              class="video-data"
              v-if="video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__11_serie && video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__11_serie.serien_hinweis"
            ><pre>Serien-Fremd-ID:  {{ video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__01_metadaten.__sort__04_idnr | toSeriesId}}</pre></p>
            <br />
            <p class="video-data">
              <b>Staffel Daten</b>
            </p>
            <p
              class="video-data"
              v-if="video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__11_serie && video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__11_serie.staffel_hinweis"
            >
              Platform Start: {{ video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__11_serie.staffel_hinweis.__sort__25_start | moment("MMMM Do YYYY") }}
            </p>
            <p
              class="video-data"
              v-if="video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__11_serie && video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__11_serie.staffel_hinweis"
            >
              Platform End: {{ video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__11_serie.staffel_hinweis.__sort__26_stop | moment("MMMM Do YYYY") }}
            </p>
            <p
              class="video-text-dark"
              v-if="video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__11_serie && video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__11_serie.staffel_hinweis"
            >
              Staffel Beschreibung: {{ burdaSeasonSynopsis }}
            </p>

            <p
              class="video-text-dark"
              v-if="video.source_data.delta_info === 'update' && video.source_data.delta_info !== 'deleted' &&
                !parseInt(video.xml_vod_data.sendung.__sort__01_id.substr(5,6)) <= 0"
            >
              Staffel Beschreibung: {{ burdaSeasonSynopsis }}
            </p>
            <p
              class="video-data"
              v-if="video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__11_serie"
            ><pre>Staffel-Fremd-ID: {{ video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__01_metadaten.__sort__04_idnr | toSeasonId }}</pre></p>
          </b-col>
        </b-row>
      </div>

      <div class="devider"></div>
      <div class="info-box">
        <div class="list-header">Source Data</div>
        <b-row class="video-details-content">
          <b-col cols="6" class="mui--text-left">
            <p class="video-title">Title: {{ video.source_data.title }}</p>
            <p class="video-data">Year: {{ video.source_data.year }}</p>
            <p
              class="video-data"
              v-if="video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__11_serie"
            >
              Season/Episode (Series): S{{ video.source_data.season | fillToTwoDigits }}E{{ video.source_data.episode | fillToTwoDigits }}
            </p>
            <p
              class="video-data"
              v-if="video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__11_serie"
            >
              Episode Title (Series): <a v-bind:href="video.source_data.episodeurl">{{ video.source_data.episodetitle }}</a>
            </p>
            <p class="video-data">Directors: {{ video.source_data.directors }}</p>
            <p class="video-data">Genres: {{ video.source_data.genres }}</p>
            <p class="video-data">Runtime: {{ video.source_data.runtime }} min</p>
            <p class="video-data">Actors: {{ video.source_data.actors }}</p>
            <p class="video-data">Language: {{ video.source_data.language }}</p>
            <p class="video-data">Countries: {{ video.source_data.countries }}</p>
            <p class="video-data">FSK: {{ video.source_data.fsk }}</p>
          </b-col>
          <b-col cols="6" class="mui--text-left">
            <p class="video-data">VoD Provider: <a v-bind:href="video.source_data.url">{{ video.source_data.provider }}</a></p>
            <p class="video-data">Catalog Links:
              <a :href="imdbUrl" v-if="imdbUrl">IMDb</a>
              <a v-bind:href="this.tmdbUrl" v-if="this.tmdbUrl">TMDb</a>
              <a v-bind:href="this.tvdbUrl" v-if="this.tvdbUrl">tvdb</a>
            </p>
            <p class="video-data">Platform Start: {{ video.source_data.start | moment("MMMM Do YYYY") }}</p>
            <p class="video-data">Platform End: {{ (platformEnd === '') ? 'REMOVED' : platformEnd | moment("MMMM Do YYYY") }}</p>
            <p class="video-data">Resolution: {{ video.source_data.resolution }}</p>
            <p class="video-data">Price: {{ video.source_data.price }}</p>
            <p class="video-data">Ending Soon: {{ video.source_data.is_ending_soon }}</p>
            <p class="video-data">Featured: {{ video.source_data.is_featured_video }}</p>
            <p class="video-data">New: {{ video.source_data.is_newly_added }}</p>
            <p class="video-data">Popular: {{ video.source_data.is_popular }}</p>
            <p class="video-data"><pre>mixd.tv ID: {{ video.source_data.mixdId }}</pre></p>
          </b-col>
        </b-row>
      </div>
      <div class="devider"></div>
      <div class="info-box">
        <div class="list-header">Export Log</div>
        <b-row class="video-details-content">
          <b-col cols="12" class="mui--text-left">
            <pre class="video-log">
              {{ video.target_data.export_log }}
            </pre>
          </b-col>
        </b-row>
      </div>
      <div class="info-box">
        <div class="list-header">Update Info (raw data before update)</div>
        <b-row class="video-details-content">
          <b-col cols="12" class="mui--text-left">
            <pre class="video-log">
              {{ video.source_data.delta_orig }}
            </pre>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
const theMovieDb = require('themoviedb-javascript-library')

// to modify IDs
// eslint-disable-next-line
String.prototype.replaceAt = function (index, replacement) {
  return this.substr(0, index) + replacement + this.substr(index + replacement.length)
}

export default {
  name: 'VideoDetails',
  props: [
    'video',
    'globalImageUrlCache'
  ],
  data () {
    return {
      tmdb_image_url: '', // http://loblawdigital.co/wp-content/uploads/2016/03/placeholder_portrait-1.jpg',
      imdbUrl: false,
      tmdbUrl: false,
      tvdbUrl: false,
      isImageShown: false
    }
  },
  mounted () {
    /* setInterval(() => {
      this.getTmdbImageUrl()
    }, 1000)
    this.getTmdbImageUrl() */
  },
  watch: {
    video: function (newVideo) {
      // when the hash prop changes, this function will be fired.
      if (newVideo === null) {
        return
      }
      if (newVideo.source_data.imdb && newVideo.source_data.imdb !== null) {
        this.imdbUrl = 'https://www.imdb.com/title/' + newVideo.source_data.imdb
      } else {
        this.imdbUrl = false
      }
      if (newVideo.source_data.tmdb && newVideo.source_data.tmdb !== null) {
        this.tmdbUrl = 'https://www.themoviedb.org/movie/' + newVideo.source_data.tmdb
      } else {
        this.tmdbUrl = false
      }
      if (newVideo.source_data.tvdb && newVideo.source_data.tvdb !== null) {
        this.tvdbUrl = 'https://www.thetvdb.com/?tab=series&id=' + newVideo.source_data.tvdb
      } else {
        this.tvdbUrl = false
      }

      if (newVideo.source_data.tvdb && newVideo.source_data.tvdb !== null &&
        newVideo.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__11_serie &&
        newVideo.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__11_serie.serien_hinweis
      ) {
        this.tvdbSeriesUrl = 'https://www.thetvdb.com/?tab=series&id=' + newVideo.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__11_serie.serien_hinweis.__sort__35_tvdb_id
      } else {
        this.tvdbSeriesUrl = false
      }

      this.getTmdbImageUrl()
    }
  },
  filters: {
    fillToTwoDigits: function (value) {
      if (!value) return ''
      let number = parseInt(value)
      if (number <= 99) {
        number = ('00' + number).slice(-2)
      }
      return number
    },
    toSeriesId: function (value) {
      if (!value) return ''
      const seriesId = value.replaceAt(4, '000000')
      return seriesId
    },
    toSeasonId: function (value) {
      if (!value) return ''
      const seriesId = value.replaceAt(6, '0000')
      return seriesId
    },
    showCountry: function (value) {
      if (!value) return ''
      value = value.split('__countryCode_devider__')[1] + ' (' + value.split('__countryCode_devider__')[0] + ')'
      return value
    }
  },
  computed: {
    burdaSeasonSynopsis () {
      // was: video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__11_serie.staffel_hinweis.__sort__37_beschreibung
      if (this.video.target_data.burda_season_synopsis) {
        return this.video.target_data.burda_season_synopsis
      }
    },
    burdaSeriesSynopsis () {
      // was: video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__02_programm.__sort__11_serie.staffel_hinweis.__sort__37_beschreibung
      if (this.video.target_data.burda_series_synopsis) {
        return this.video.target_data.burda_series_synopsis
      }
    },
    targetImdbUrl () {
      if (this.video.target_data.imdb_id) {
        return `https://www.imdb.com/title/${this.video.target_data.imdb_id}/`
      }
    },
    targetTmdbUrl () {
      if (this.video.target_data.tmdb_id) {
        return `https://www.themoviedb.org/movie/${this.video.target_data.tmdb_id}`
      }
    },
    targetTvdbUrl () {
      if (this.video.target_data.tvdb_id) {
        return `http://thetvdb.com/?tab=series&id=${this.video.target_data.tvdb_id}&lid=14`
      }
    },
    broadcastData () {
      return this.video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__04_ausstrahlung
    },
    hasFlagHdtv () {
      if (this.broadcastData && this.broadcastData['__sort__15_video-attribute']) {
        return this.broadcastData['__sort__15_video-attribute'].__sort__15_hdtv
      } else {
        return ''
      }
    },
    hasFlagUhd () {
      if (this.broadcastData && this.broadcastData['__sort__15_video-attribute']) {
        return this.broadcastData['__sort__15_video-attribute'].__sort__16_uhd
      } else {
        return ''
      }
    },
    platformEnd () {
      console.log('this.video', this.video)
      const stopValue = this.video.source_data.end
      console.log('stopValue', stopValue)

      // if (video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__04_ausstrahlung) {
      //   stopValue = video.xml_vod_data.sendung.__sort__02_standard.__sort__01_stammdaten.__sort__04_ausstrahlung.__sort__03_stop
      // }

      // if (stopValue === '') {
      //   return 'removed'
      // }
      return stopValue
    },
    prices () {
      return {
        buy: {
          sd: this.broadcastData.__sort__22_prices && this.broadcastData.__sort__22_prices.__sort__01_buy.__sort__01_sd,
          hd: this.broadcastData.__sort__22_prices && this.broadcastData.__sort__22_prices.__sort__01_buy.__sort__02_hd,
          uhd: this.broadcastData.__sort__22_prices && this.broadcastData.__sort__22_prices.__sort__01_buy.__sort__03_uhd,
        },
        rent: {
          sd: this.broadcastData.__sort__22_prices && this.broadcastData.__sort__22_prices.__sort__02_rent.__sort__01_sd,
          hd: this.broadcastData.__sort__22_prices && this.broadcastData.__sort__22_prices.__sort__02_rent.__sort__02_hd,
          uhd: this.broadcastData.__sort__22_prices && this.broadcastData.__sort__22_prices.__sort__02_rent.__sort__03_uhd
        }
      }
    }
  },
  methods: {
    getTmdbImageUrl () {
      this.$nextTick(function () {
        theMovieDb.common.api_key = '83b6a107b86cc443e3bc47a44474f521'
        let PLACEHOLER_IMAGE_PATH = 'http://images.mixd.tv/images/default.png'
        // console.log(this.video.source_data.tmdb)

        this.video.tmdb_image_url = PLACEHOLER_IMAGE_PATH
        this.tmdb_image_url = PLACEHOLER_IMAGE_PATH

        if (this.video.source_data.tmdb === null || this.video.source_data.tmdb === undefined) {
          console.log('will not requst Img of unser tmdb')
          if (this.video.source_data.imdb === null || this.video.source_data.imdb === undefined) {
            console.log('missing info')
          } else {
            let lookupUrl = 'http://vod-qa-dashboard.mixd.tv:3000/imdb_cover_url/' + this.video.source_data.imdb
            if (Object.keys(this.globalImageUrlCache).includes(lookupUrl)) {
              this.video.tmdb_image_url = this.globalImageUrlCache[lookupUrl]
              this.tmdb_image_url = this.video.tmdb_image_url
            } else {
              axios.get(lookupUrl).then(response => {
                this.globalImageUrlCache[lookupUrl] = response.data.coverUrl
                // console.log('setting to ' + response.data.coverUrl)
                this.video.tmdb_image_url = response.data.coverUrl
                this.tmdb_image_url = response.data.coverUrl
              })
            }
          } // imdb image lookup
        } else {
          console.log('requesting IMG from TMDb for ' + this.video.source_data.tmdb)

          theMovieDb.movies.getById({'id': this.video.source_data.tmdb, 'language': 'de'}, (data) => {
            let jsonData = JSON.parse(data)
            let posterPath = 'https://image.tmdb.org/t/p/w1280' + jsonData['poster_path']
            // console.log('data is' + jsonData)
            console.log('Setting post path from TMDb to ' + posterPath)
            this.video.tmdb_image_url = posterPath
            this.tmdb_image_url = posterPath
          }, () => { // (error) => {
            // console.log('error for ' + this.video.source_data.tmdb + 'Error:' + error)
            setTimeout(() => {
              if (this.tmdb_image_url === PLACEHOLER_IMAGE_PATH) {
                this.getTmdbImageUrl() // retrying
              }
            }, 3000)
          })
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* .details {
  width: fit-content;
} */
.list-header {
  background-color: rgba(255,255,255,0.4);
  color: #000;
  font-size: 12px;
  height: 19px;
}
.scroll-box {
  overflow-y: scroll;
  height: calc(100% - 19px);
}
.video-details-content {
  /* background-color: rgba(255,255,255,0.2); */
  color: #000;
  margin: 0;
  padding: 5px;
  background-color: #fff;
  display: flex;
}
.info-box {

}
.video-entry {
  background-color: #fff;
  color: #000;
  margin-bottom: 1px;
  display: flex;
}
.ratings {
    font-size: 12px;
    color: #888;
    position: relative;
    bottom: 5px;
}
.sub-headline {
    padding-left: 5px;
    padding-right: 5px;
    text-align: left;
    font-size: 12px;
    color: #888;
}

.starbox {
    padding-left: 10px;
    padding-right: 10px;
    text-align: left;
}

.video-image2 {
  width: 192px;
  height: 100%;
}

.video-title {
  text-align: left;
  padding-top: 3px;
  padding-left: 5px;
  padding-right: 5px;
  margin-bottom: 0px;
  color: #333;
  font-size: 12px;
  font-weight: bold;
  max-height: 20px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.video-data {
  text-align: left;
  padding-top: 3px;
  padding-left: 5px;
  padding-right: 5px;
  margin-bottom: 0px;
  color: #333;
  font-size: 10px;
  max-height: 20px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.video-log {
  white-space: pre-line;
  text-align: left;
  padding-top: 3px;
  padding-left: 5px;
  padding-right: 5px;
  margin-bottom: 0px;
  color: #333;
  font-size: 12px;
  font-weight: bold;
}
.video-info {
  text-align: left;
  padding-top: 3px;
  padding-left: 5px;
  padding-right: 5px;
  margin-bottom: 0px;
  color: #888;
  font-size: 12px;
  max-height: 20px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.video-text {
  text-align: left;
  padding-left: 5px;
  padding-right: 5px;
  padding-top: 3px;
  padding-bottom: 3px;
  margin-bottom: 0px;
  font-size: 10px;
  color: #888;
  -webkit-line-clamp: 5;
  overflow: hidden;
  -webkit-box-orient: vertical;
  display: -webkit-box;
}

.video-text-dark {
  text-align: left;
  padding-left: 5px;
  padding-right: 5px;
  padding-top: 3px;
  padding-bottom: 3px;
  margin-bottom: 0px;
  font-size: 10px;
  color: #333;
  -webkit-line-clamp: 15;
  overflow: hidden;
  -webkit-box-orient: vertical;
  display: -webkit-box;
}

.devider{
  height: 1px;
  margin-left: 0px;
  margin-right: 0px;
  background-color: #bbb;
}

.video-more {
  padding-top: 10px;
  padding-bottom: 10px;
  text-align: center;
  font-size: small;
  color: #106AD7;
}

.season-data {
  background-color: rgba(0,0,0,0.2);;
}

</style>



// WEBPACK FOOTER //
// src/components/VideoDetails.vue